import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";

interface U2104OrganizationIconDeleteDlgProps {
  isOpen: boolean;
  onClose: (result: "yes" | "no") => void;
  t: TFunction;
  NS: string;
}

function U2104OrganizationIconDeleteDlg({ isOpen, onClose, t, NS }: U2104OrganizationIconDeleteDlgProps) {
  if (!isOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={isOpen} onClose={onClose} title={t("lblOrganizationIcon", { ns: NS })}>
      <p className="mb-4">{t("msgDeleteIconConfirm", { ns: NS })}</p>
    </U2000DeleteRecordDialog>
  );
}

export default U2104OrganizationIconDeleteDlg;
